<template>
    <div class="relative">
        <input
            :type="showPassword ? 'text' : 'password'"
            :value="modelValue"
            @input="$emit('update:modelValue', $event.target.value)"
            :placeholder="placeholder"
            :required="required"
            class="block px-4 py-3 w-full text-gray-900 rounded-xl border-0 ring-1 ring-inset ring-gray-300 shadow-sm placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            :class="{ 'pr-10': true }" />
        <button
            type="button"
            @click="togglePassword"
            class="flex absolute inset-y-0 right-0 items-center pr-3 text-gray-400 hover:text-gray-500">
            <EyeIcon v-if="showPassword" class="w-5 h-5" />
            <EyeSlashIcon v-else class="w-5 h-5" />
        </button>
    </div>
</template>

<script setup>
import { ref } from 'vue';
import { EyeIcon, EyeSlashIcon } from '@heroicons/vue/24/outline';

const props = defineProps({
  modelValue: {
    type: String,
    default: '',
  },
  placeholder: {
    type: String,
    default: 'Password',
  },
  required: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['update:modelValue']);

const showPassword = ref(false);

const togglePassword = () => {
  showPassword.value = !showPassword.value;
};
</script>
